import React from "react";
import { PageHeader } from "@/components/shared/SectionHeader";
import { Link } from "react-router-dom";

const TEAM = [
  { name: "Tony Nila", role: "Faculty · Cognitive Development", img: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { name: "Nicole Brophy", role: "Faculty · Genetics & Breeding", img: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { name: "Dr. Mara Lee, DVM", role: "Faculty · Veterinary Medicine", img: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { name: "James Okafor", role: "Faculty · Containment & Property", img: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
];

const PARTNERS = ["Silverpaw Sanctuary","Whitepine Wolfdogs","Cedar Ridge Kennels","Northern Lights Rescue","Wild Table Nutrition","Okafor Containment Co."];

export default function About() {
  return (
    <div>
      <PageHeader
        eyebrow="About"
        title="A modern institution for a species in the middle."
        description="Wolfdog Village exists to elevate the entire ecosystem — from first-time owners to breeders, veterinarians, sanctuaries and legislators."
        image="https://images.unsplash.com/photo-1542273917363-3b1817f69a2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400"
      />

      <section className="container-x py-16 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-8">
          <div className="eyebrow">Our mission</div>
          <h2 className="font-display text-4xl md:text-5xl mt-3 leading-tight text-balance">Educating people. Strengthening relationships. Improving the future of wolfdogs.</h2>
          <p className="mt-6 text-muted-foreground text-lg text-pretty">
            We built Wolfdog Village to raise the standard of ownership and stewardship. Not another forum. Not a marketplace. An institution — grounded in cognitive science, veterinary medicine and lived experience.
          </p>

          <div className="mt-14 eyebrow">Our vision</div>
          <p className="mt-3 text-lg text-pretty">A world where every wolfdog gets the right start — and every owner, breeder and sanctuary has the education to make it possible.</p>

          <div className="mt-14 eyebrow">History</div>
          <p className="mt-3 text-lg text-pretty">Founded by a coalition of educators, breeders and cognitive scientists, Wolfdog Village opened its virtual doors in 2024 and now serves more than 5,000 certified learners across the world.</p>

          <div className="mt-14 eyebrow">Educational Philosophy</div>
          <p className="mt-3 text-lg text-pretty">Cognitive-first. Evidence-based. Community-supported. We believe education is a lifelong practice — and that ownership is a lifelong commitment.</p>
        </div>

        <aside className="lg:col-span-4">
          <div className="rounded-lg border border-border bg-card p-6">
            <div className="eyebrow">By the numbers</div>
            <dl className="mt-4 space-y-4">
              {[
                ["5,000+","Certified learners"],
                ["42","Faculty & mentors"],
                ["8","Signature programs"],
                ["51","Legal jurisdictions covered"],
              ].map(([n, l]) => (
                <div key={l} className="flex items-baseline justify-between border-b border-border pb-3">
                  <dt className="text-sm text-muted-foreground">{l}</dt>
                  <dd className="font-display text-2xl">{n}</dd>
                </div>
              ))}
            </dl>
          </div>
        </aside>
      </section>

      <section className="container-x pb-24">
        <div className="eyebrow">Meet the faculty</div>
        <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-6">
          {TEAM.map(t => (
            <div key={t.name} className="group">
              <div className="aspect-[3/4] overflow-hidden rounded-lg border border-border">
                <img src={t.img} alt={t.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="font-display text-xl mt-3">{t.name}</div>
              <div className="eyebrow mt-1">{t.role}</div>
            </div>
          ))}
        </div>

        <div className="mt-20 eyebrow">Partner organizations</div>
        <div className="mt-4 flex flex-wrap gap-3">
          {PARTNERS.map(p => (
            <span key={p} className="text-sm px-4 py-2 rounded-full border border-border text-muted-foreground">{p}</span>
          ))}
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            { t: "Donate", d: "Support scholarships for future owners and sanctuary programs." },
            { t: "Volunteer", d: "Mentor future owners, run a chapter, help a sanctuary." },
            { t: "Partner", d: "Bring your organization into the Wolfdog Village standard." },
          ].map(x => (
            <div key={x.t} className="rounded-lg border border-border p-6 bg-card">
              <div className="font-display text-2xl">{x.t}</div>
              <p className="mt-2 text-sm text-muted-foreground">{x.d}</p>
              <Link to="/contact" className="btn-outline mt-4 !py-2 !px-4 text-xs">Get in touch</Link>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
